import * as React from "react";
import {Box} from "@unibuddy/patron";

export const EmptyAvatar: React.FC = () => (
    <Box data-test-id="chat-message-placeholder-avatar" w="45px" h="1px" />
);
